// 各メニュー
const menuItem = {
  home: { title: 'ホーム', iconComponent: 'HomeIcon', url: '/' },
  package: { title: '占いTVお試しパック', url: '/package', tgtBlank: false },

  // recommend lp 系
  kanococo: { title: '叶ここの天宝占術', url: '/recommend/lp/2', tgtBlank: false },
  kurenotori: { title: '暮れの酉の鳳凰数術', url: '/recommend/lp/1', tgtBlank: false },
  towa: { title: '斗弥の属性開抛', url: '/recommend/lp/3', tgtBlank: false },
  hoen: { title: '法演のMITSURI', url: '/recommend/lp/4', tgtBlank: false },
  ottimo: { title: 'オッティモちゃんの宇宙占術RPU', url: '/recommend/lp/5', tgtBlank: false },
  somarimone: { title: 'そまり百音のねこ風水', url: '/recommend/lp/6', tgtBlank: false },

  // 年運
  yearluck: { title: '超運2023年の運勢', url: '/2023_luck', tgtBlank: false },

  // ordermade: { title: 'オーダーメイド型占い', url: '/category/ordermade', tgtBlank: false },

  // 高額メニュー
  deluxe1: { title: '［特典］片思いを4人で占う', url: '/deluxe/lp/1', tgtBlank: false },

  // ヘルプ系
  news: { title: 'キャンペーン・お知らせ', url: '/news', tgtBlank: false },
  faq: { title: 'よくある質問', url: '/faq', tgtBlank: false },
  inquiry: { title: 'お問い合わせ', url: '/help/inquiry', tgtBlank: false },
  privacy: { title: 'プライバシーポリシー', url: '/privacy', tgtBlank: false },
  terms: { title: '利用規約', url: '/terms', tgtBlank: false },
  cookie: { title: 'Cookie利用について', url: '/cookie', tgtBlank: false },
  legal: { title: '特定商取引法に基づく表記', url: '/legal', tgtBlank: false },
  company: { title: '運営会社', url: 'https://www.zappallas.com/', tgtBlank: true },

  // 会員メニュー系
  paymentLibrary: { title: '申込・購入済み', url: '/payment/library', tgtBlank: false },
  account: { title: 'アカウント情報を管理', url: '/user/account', tgtBlank: false },
  magazine: { title: 'メールマガジンを管理', url: '/user/account/magazine', tgtBlank: false },
  profile: { title: '占いに使う情報を管理', url: '/user/account/profile', tgtBlank: false },
  targetList: { title: '占いに使う相手の情報を管理', url: '/user/account/target_list', tgtBlank: false },
  status: { title: 'お支払い情報を管理', url: '/user/account/status', tgtBlank: false },
  point: { title: 'ポイントを管理', url: '/user/account/point', tgtBlank: false },
  paymentHistory: { title: '購入履歴', iconComponent: 'PurchaseIcon', url: '/user/account/payment_history', children: [] },
  logout: { title: 'ログアウト', iconComponent: 'LogoutIcon', url: '/user/logout', closeModal: true },
}

// メニューセット
const menuSet = {
  purchase: {
    title: '購入',
    iconComponent: 'PurchaseIcon',
    children: [
      menuItem.package,
      menuItem.ottimo,
      menuItem.kanococo,
      menuItem.kurenotori,
      menuItem.somarimone,
      menuItem.towa,
      menuItem.hoen,
      menuItem.yearluck,
      // menuItem.ordermade,
    ]
  },
  purchaseSubsc: {
    title: '購入',
    iconComponent: 'PurchaseIcon',
    children: [
      menuItem.yearluck,
      menuItem.package,
    ]
  },
  help: {
    title: 'ヘルプ',
    iconComponent: 'HelpIcon',
    isFooterHidden: true,
    children: [
      menuItem.news,
      menuItem.faq,
      menuItem.inquiry,
      menuItem.privacy,
      menuItem.terms,
      menuItem.cookie,
      menuItem.legal,
      menuItem.company,
    ],
  },
  account: {
    children: [
      menuItem.account,
      menuItem.magazine,
      menuItem.profile,
      menuItem.targetList,
    ]
  },
  point: {
    title: `保有ポイント`, iconComponent: 'PointIcon',
    children: [
      menuItem.point
    ]
  },
}

//ヘッダーフッターメニュー
export const MENU = {
  //非会員
  NO_MEMBER: [
    menuItem.home,
    menuSet.purchase,
    menuSet.help,
  ],

  // ID会員
  ID: [
    menuItem.home,
    menuSet.purchase,
    {
      title: 'ライブラリー',
      iconComponent: 'LibraryIcon',
      children: [
        menuItem.paymentLibrary,
      ]
    },
    menuSet.help,
  ],

  // サブスク会員
  SUBSC: [
    menuItem.home,
    {
      title: 'さがす',
      iconComponent: 'SearchIcon',
      children: [
        {
          title: 'カテゴリーでさがす',
          url: '/category/5',
          tgtBlank: false
        },
        {
          title: '占い師でさがす',
          url: '/category/3',
          tgtBlank: false
        },
        /*
        {
          title: '占い方でさがす',
          url: '/category/4',
          tgtBlank: false
        },
        {
          title: '新着順でさがす',
          url: '/tag/new',
          tgtBlank: false
        },
         */
        {
          title: '今日のおすすめ',
          url: '/tag/77777',
          tgtBlank: false
        },
        {
          title: '今週のピックアップ	',
          url: '/tag/88888',
          tgtBlank: false
        },
        {
          title: '動画占い',
          url: '/tag/weekly_video?movies=1',
          tgtBlank: false
        },

      ]
    },
    {
      title: '人気の占い師',
      iconComponent: 'SearchIcon',
      children: [
        {
          title: '暮れの酉：占い特集',
          url: '/products/86',
          tgtBlank: false
        },
        {
          title: '法演：MITSURI特集',
          url: '/products/45',
          tgtBlank: false
        },
        {
          title: '斗弥：占い特集',
          url: '/products/88',
          tgtBlank: false
        },
        {
          title: 'そまり百音：3年の運気',
          url: '/products/44/0001/result',
          tgtBlank: false
        },
        {
          title: '叶ここ：10年の人生年表',
          url: '/products/87/0001/result',
          tgtBlank: false
        },
      ]
    },
    {
      title: '申し込み（無料）',
      iconComponent: 'PrivilegeIcon',
      isFooterHidden: true,
      children: [
        /*
        {
          title: '［特典］鑑定動画',
          url: '/favor/contents',
          tgtBlank: false
        },
         */
        {
          // 非活性コメント付きにしたい場合は以下適用
          // title: '<span class="disabledLink">［特典］動画占い<span class="info">※2週間お試し終了後にお申し込みできます。</span></span>',
          // isDisabled: true,
          title: '［特典］動画占い',
          url: '/lp/present_movie',
          tgtBlank: false
        },
        menuItem.deluxe1,
      ]
    },
    menuSet.purchaseSubsc,
    {
      title: 'ライブラリー',
      iconComponent: 'LibraryIcon',
      children: [
        {
          title: '閲覧履歴',
          url: '/history',
          tgtBlank: false
        },
        menuItem.paymentLibrary,
        {
          title: 'お気に入り',
          url: '/favorite',
          tgtBlank: false
        },
        {
          title: 'あとで見る',
          url: '/history/later',
          tgtBlank: false
        }
      ]
    },
    menuSet.help,
  ]
}

// アカウントメニュー
export const ACCOUNT_MENU = {
  // ID会員
  ID: [
    menuSet.account,
    {
      title: 'サブスクリプション未登録',
      iconComponent: 'SubscTypeIcon',
      children: [
        menuItem.status,
        {
          title: 'サブスクリプションの申込',
          url: '/subsc/join',
          tgtBlank: false,
          closeModal: true
        }
      ]
    },
    menuSet.point,
    menuItem.paymentHistory,
    menuItem.logout
  ],
  // サブスク会員
  SUBSC: [
    menuSet.account,
    {
      title: 'サブスクリプション継続中',
      iconComponent: 'SubscTypeIcon',
      children: [
        menuItem.status,
        {
          title: 'サブスクリプションの解約',
          url: '/subsc/cancel',
          tgtBlank: false
        }
      ]
    },
    menuSet.point,
    menuItem.paymentHistory,
    menuItem.logout
  ]
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/common/const.js